<div class="flex h-8 gap-1">
  <div class="flex h-8 w-[82px] justify-end gap-1">
    <lib-perio-cheat-sheet-key [disabled]="disabled()">
      <ng-content select="[characterKey]" />
    </lib-perio-cheat-sheet-key>
    <div class="perio-cheatsheet-additional-key-wrapper contents">
      <span class="flex items-center" [ngClass]="{ 'text-text-secondary': !disabled(), 'text-text-light': disabled() }">+</span>
      <lib-perio-cheat-sheet-key [disabled]="disabled()">
        <span class="perio-cheatsheet-additional-key contents">
          <ng-content select="[anotherCharacterKey]" />
        </span>
      </lib-perio-cheat-sheet-key>
    </div>
  </div>
  <div
    class="leading-super-tight typo-h6-light ml-2 flex w-[117px] items-center"
    [ngClass]="{ 'text-text-tertiary': !disabled(), 'text-text-light': disabled() }"
  >
    <ng-content select="[leadText]" />
  </div>
</div>
